import dayjs from 'dayjs';

import { Skeleton, Stack } from '@cast/design-system';

import { usePlatformUsageDetailQuery } from 'hooks/queries/organization';

import { DATABASE_OPTIMIZATION_FEATURE_KEY } from './database-optimization/constants';
import { DatabaseOptimizationUsageDetail } from './database-optimization/DatabaseOptimizationUsageDetail';
import { DetailOverviewCard } from './_components/DetailOverviewCard';
import { PlatformUsageChartsAndTables } from './_components/PlatformUsageChartsAndTables';

type PlatformUsageDetailProps = {
  feature: string;
};

const ClassicPlatformUsageDetail = ({ feature }: PlatformUsageDetailProps) => {
  const currentMonthFrom = dayjs().startOf('month').format('YYYY-MM-DD');
  const currentMonthTo = dayjs().endOf('month').format('YYYY-MM-DD');

  const { data: overviewData, isLoading: isOverviewLoading } =
    usePlatformUsageDetailQuery({
      feature,
      periodFrom: currentMonthFrom,
      periodTo: currentMonthTo,
    });

  const overviewDetail = overviewData?.detail;

  return (
    <Stack gap={24}>
      {isOverviewLoading ? (
        <Skeleton
          variant="rectangular"
          height={122}
          sx={{ borderRadius: '4px' }}
          data-testid="detail-overview-loading"
        />
      ) : (
        overviewDetail && <DetailOverviewCard detail={overviewDetail} />
      )}

      <PlatformUsageChartsAndTables feature={feature} />
    </Stack>
  );
};

export const PlatformUsageDetail = ({ feature }: PlatformUsageDetailProps) => {
  if (feature === DATABASE_OPTIMIZATION_FEATURE_KEY) {
    return <DatabaseOptimizationUsageDetail feature={feature} />;
  }

  return <ClassicPlatformUsageDetail feature={feature} />;
};
